/**
 * API Documentation for EHS tools
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Member from '../model/Member';
import PageUser from '../model/PageUser';
import User from '../model/User';

/**
* Usercontroller service.
* @module api/UsercontrollerApi
* @version 1.0
*/
export default class UsercontrollerApi {

    /**
    * Constructs a new UsercontrollerApi. 
    * @alias module:api/UsercontrollerApi
    * @class
    * @param {module:ApiClient} apiClient Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * addRole
     * @param {Number} id id
     * @param {String} roleName roleName
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/User} and HTTP response
     */
    addRoleWithHttpInfo(id, roleName) {
      let postBody = roleName;

      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling addRole");
      }

      // verify the required parameter 'roleName' is set
      if (roleName === undefined || roleName === null) {
        throw new Error("Missing the required parameter 'roleName' when calling addRole");
      }


      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = User;

      return this.apiClient.callApi(
        '/api/users/{id}/roles', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * addRole
     * @param {Number} id id
     * @param {String} roleName roleName
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/User}
     */
    addRole(id, roleName) {
      return this.addRoleWithHttpInfo(id, roleName)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * adminChangePassword
     * @param {Number} id id
     * @param {String} password password
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Member} and HTTP response
     */
    adminChangePasswordWithHttpInfo(id, password) {
      let postBody = password;

      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling adminChangePassword");
      }

      // verify the required parameter 'password' is set
      if (password === undefined || password === null) {
        throw new Error("Missing the required parameter 'password' when calling adminChangePassword");
      }


      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = Member;

      return this.apiClient.callApi(
        '/api/users/{id}/password', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * adminChangePassword
     * @param {Number} id id
     * @param {String} password password
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Member}
     */
    adminChangePassword(id, password) {
      return this.adminChangePasswordWithHttpInfo(id, password)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * changePassword
     * @param {String} password password
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Member} and HTTP response
     */
    changePasswordWithHttpInfo(password) {
      let postBody = password;

      // verify the required parameter 'password' is set
      if (password === undefined || password === null) {
        throw new Error("Missing the required parameter 'password' when calling changePassword");
      }


      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = Member;

      return this.apiClient.callApi(
        '/api/users/currentuser/password', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * changePassword
     * @param {String} password password
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Member}
     */
    changePassword(password) {
      return this.changePasswordWithHttpInfo(password)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * deleteRole
     * @param {Number} id id
     * @param {String} roleName roleName
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Member} and HTTP response
     */
    deleteRoleWithHttpInfo(id, roleName) {
      let postBody = roleName;

      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteRole");
      }

      // verify the required parameter 'roleName' is set
      if (roleName === undefined || roleName === null) {
        throw new Error("Missing the required parameter 'roleName' when calling deleteRole");
      }


      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = Member;

      return this.apiClient.callApi(
        '/api/users/{id}/roles', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * deleteRole
     * @param {Number} id id
     * @param {String} roleName roleName
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Member}
     */
    deleteRole(id, roleName) {
      return this.deleteRoleWithHttpInfo(id, roleName)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * deleteUser
     * @param {Number} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'Boolean'} and HTTP response
     */
    deleteUserWithHttpInfo(id) {
      let postBody = null;

      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteUser");
      }


      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = 'Boolean';

      return this.apiClient.callApi(
        '/api/users/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * deleteUser
     * @param {Number} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'Boolean'}
     */
    deleteUser(id) {
      return this.deleteUserWithHttpInfo(id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * disableUser
     * @param {String} disabled disabled
     * @param {Number} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'Boolean'} and HTTP response
     */
    disableUserWithHttpInfo(disabled, id) {
      let postBody = disabled;

      // verify the required parameter 'disabled' is set
      if (disabled === undefined || disabled === null) {
        throw new Error("Missing the required parameter 'disabled' when calling disableUser");
      }

      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling disableUser");
      }


      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = 'Boolean';

      return this.apiClient.callApi(
        '/api/users/{id}/disable', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * disableUser
     * @param {String} disabled disabled
     * @param {Number} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'Boolean'}
     */
    disableUser(disabled, id) {
      return this.disableUserWithHttpInfo(disabled, id)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * getUser
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/User} and HTTP response
     */
    getUserWithHttpInfo() {
      let postBody = null;


      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = User;

      return this.apiClient.callApi(
        '/api/users/current_user', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * getUser
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/User}
     */
    getUser() {
      return this.getUserWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * getUsers
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page page (default to 0)
     * @param {Number} opts.pageSize pageSize (default to 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PageUser} and HTTP response
     */
    getUsersWithHttpInfo(opts) {
      opts = opts || {};
      let postBody = null;


      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'pageSize': opts['pageSize']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = PageUser;

      return this.apiClient.callApi(
        '/api/users', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * getUsers
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page page (default to 0)
     * @param {Number} opts.pageSize pageSize (default to 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PageUser}
     */
    getUsers(opts) {
      return this.getUsersWithHttpInfo(opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * registration
     * @param {module:model/User} user user
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/User} and HTTP response
     */
    registrationWithHttpInfo(user) {
      let postBody = user;

      // verify the required parameter 'user' is set
      if (user === undefined || user === null) {
        throw new Error("Missing the required parameter 'user' when calling registration");
      }


      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = User;

      return this.apiClient.callApi(
        '/registration', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * registration
     * @param {module:model/User} user user
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/User}
     */
    registration(user) {
      return this.registrationWithHttpInfo(user)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * updateUser
     * @param {module:model/User} user user
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/User} and HTTP response
     */
    updateUserWithHttpInfo(user) {
      let postBody = user;

      // verify the required parameter 'user' is set
      if (user === undefined || user === null) {
        throw new Error("Missing the required parameter 'user' when calling updateUser");
      }


      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['spring_oauth'];
      let contentTypes = ['application/json'];
      let accepts = ['*/*'];
      let returnType = User;

      return this.apiClient.callApi(
        '/api/users/currentuser', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    }

    /**
     * updateUser
     * @param {module:model/User} user user
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/User}
     */
    updateUser(user) {
      return this.updateUserWithHttpInfo(user)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
